var _defs, _style, _use, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCongratulationIcon = function SvgCongratulationIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "img1",
    width: 66,
    height: 66,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCAQMAAADZmpKrAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAA9JREFUeJxjYBgFo2BwAQAClAABXJqgXwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 33,
    x2: 33,
    y1: 41.2,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a295b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003cd5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 33.3,
    x2: 33.3,
    y1: 21,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:url(#g1)}.s1{fill:url(#g2)}")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    x: 0,
    y: 0,
    href: "#img1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1030",
    d: "m33 66c-18.2 0-33-14.8-33-33 0-18.2 14.8-33 33-33 18.2 0 33 14.8 33 33 0 18.2-14.8 33-33 33z",
    className: "s0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 20150315101582807000,
    fillRule: "evenodd",
    d: "m30.9 22.5c0.9-2 3.8-2 4.7 0l1.9 4.3c0.7 1.6 2.6 2.1 3.9 1l3-2.3c1.8-1.5 4.6 0.1 4.1 2.5l-2.7 13c-0.4 1.8-2 3-3.8 3h-17.5c-1.8 0-3.4-1.2-3.8-3l-2.7-13c-0.4-2.4 2.3-4 4.1-2.5l3 2.3c1.3 1.1 3.2 0.6 3.9-1zm2.3 1.1l-1.9 4.3c-1.4 3.1-5.2 4-7.9 1.9l-2.9-2.3 2.7 13c0.1 0.6 0.7 1 1.3 1h17.5c0.6 0 1.1-0.4 1.3-1l2.7-13-3 2.3c-2.6 2.1-6.5 1.2-7.8-1.9z",
    className: "s1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCongratulationIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NiIgaGVpZ2h0PSI2NiIgdmVyc2lvbj0iMS4yIiB2aWV3Qm94PSIwIDAgNjYgNjYiPjx0aXRsZT5OZXcgUHJvamVjdDwvdGl0bGU+PGRlZnM+PGltYWdlIGlkPSJpbWcxIiB3aWR0aD0iNjYiIGhlaWdodD0iNjYiIGhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBRUlBQUFCQ0FRTUFBQURabXBLckFBQUFBWE5TUjBJQjJja3Nmd0FBQUFOUVRGUkYvLy8vcDhRYnlBQUFBQTlKUkVGVWVKeGpZQmdGbzJCd0FRQUNsQUFCWEpxZ1h3QUFBQUJKUlU1RXJrSmdnZz09Ii8+PGxpbmVhckdyYWRpZW50IGlkPSJnMSIgeDE9IjMzIiB4Mj0iMzMiIHkxPSI0MS4yIiB5Mj0iODAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxYTI5NWIiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDNjZDUiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCBpZD0iZzIiIHgxPSIzMy4zIiB4Mj0iMzMuMyIgeTE9IjIxIiB5Mj0iNDAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNmZmI2NTciLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmYiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48c3R5bGU+LnMwe2ZpbGw6dXJsKCNnMSl9LnMxe2ZpbGw6dXJsKCNnMil9PC9zdHlsZT48dXNlIGlkPSJCYWNrZ3JvdW5kIiB4PSIwIiB5PSIwIiBocmVmPSIjaW1nMSIvPjxwYXRoIGlkPSJFbGxpcHNlIDEwMzAiIGQ9Im0zMyA2NmMtMTguMiAwLTMzLTE0LjgtMzMtMzMgMC0xOC4yIDE0LjgtMzMgMzMtMzMgMTguMiAwIDMzIDE0LjggMzMgMzMgMCAxOC4yLTE0LjggMzMtMzMgMzN6IiBjbGFzcz0iczAiLz48cGF0aCBpZD0iMjAxNTAzMTUxMDE1ODI4MDcwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0ibTMwLjkgMjIuNWMwLjktMiAzLjgtMiA0LjcgMGwxLjkgNC4zYzAuNyAxLjYgMi42IDIuMSAzLjkgMWwzLTIuM2MxLjgtMS41IDQuNiAwLjEgNC4xIDIuNWwtMi43IDEzYy0wLjQgMS44LTIgMy0zLjggM2gtMTcuNWMtMS44IDAtMy40LTEuMi0zLjgtM2wtMi43LTEzYy0wLjQtMi40IDIuMy00IDQuMS0yLjVsMyAyLjNjMS4zIDEuMSAzLjIgMC42IDMuOS0xem0yLjMgMS4xbC0xLjkgNC4zYy0xLjQgMy4xLTUuMiA0LTcuOSAxLjlsLTIuOS0yLjMgMi43IDEzYzAuMSAwLjYgMC43IDEgMS4zIDFoMTcuNWMwLjYgMCAxLjEtMC40IDEuMy0xbDIuNy0xMy0zIDIuM2MtMi42IDIuMS02LjUgMS4yLTcuOC0xLjl6IiBjbGFzcz0iczEiLz48L3N2Zz4=";